import React, { useState } from 'react';
import { Mui } from '@osu/react-ui';
import { PROGRAMS } from '../../util/constants';
import { hasDualProgramAccess } from '../../util/scholars/scholarsScope';
import { getEffectiveDefaultProgramSide, setPreferredProgramSide } from '../../util/scholars/preferredProgramSide';
import useRoleAuthentication from '../../Authentication/hooks/useRoleAuthentication';

// has543 — explicit "Default landing" preference control (navbar, next to the program-type toggle).
// This is the ONLY control that changes the persisted default landing; the program-type toggle just
// navigates in-session. Visible to any cross-program user (has543v2 — same gate as the toggle).
// Changing it persists the choice, so on future logins the app lands the user on that side (see the
// Dashboard "/" redirect).
export default function DefaultLandingPreference() {
    const { roles = [] } = useRoleAuthentication();
    // Seed from the stored value (Honors when unset). localStorage is not reactive, so mirror it in state.
    const [preferred, setPreferred] = useState(() => getEffectiveDefaultProgramSide());

    // Hidden entirely unless the user has a role on BOTH sides (has543v2 — any dual role, not just admin).
    if (!hasDualProgramAccess(roles)) { return <React.Fragment />; }

    const handleChange = (event) => {
        const next = event?.target?.value;
        if (next !== PROGRAMS.HONORS.KEY && next !== PROGRAMS.SCHOLARS.KEY) { return; }
        if (setPreferredProgramSide(next)) { setPreferred(next); }
    };

    const labelId = 'default-landing-preference-label';

    return (
        <Mui.FormControl size="small" sx={{ minWidth: 180, marginRight: '1rem' }} data-testid="default-landing-preference">
            <Mui.InputLabel id={labelId}>Default landing</Mui.InputLabel>
            <Mui.Select
                labelId={labelId}
                label="Default landing"
                value={preferred}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'Default landing page' }}
            >
                <Mui.MenuItem value={PROGRAMS.HONORS.KEY} data-testid="default-landing-honors">{PROGRAMS.HONORS.label}</Mui.MenuItem>
                <Mui.MenuItem value={PROGRAMS.SCHOLARS.KEY} data-testid="default-landing-scholars">{PROGRAMS.SCHOLARS.label}</Mui.MenuItem>
            </Mui.Select>
        </Mui.FormControl>
    );
}
